export type MatchActionsParams = {
  gameId: string;
  matchId: string;
  tournamentId: string;
};

export const useMatchActions = ({
  gameId,
  matchId,
  tournamentId,
}: MatchActionsParams) => {
  const declareWinner = async (
    winnerId: string,
    team1Score?: number,
    team2Score?: number,
  ) => {
    if (!winnerId) {
      console.log('no id');
      return;
    }
    const { finishMatch } = await import(
      '../firebaseCloud/tournament/finishMatch'
    );
    await finishMatch({
      gameId,
      matchId,
      tournamentId,
      winnerId,
      team1Score,
      team2Score,
    });
    return 'win';
  };

  const delayMatch = async () => {
    const { setMatchStatus } = await import(
      '../firebaseCloud/tournament/setMatchStatus'
    );
    await setMatchStatus({
      gameId,
      matchId,
      status: 'delayed',
      tournamentId,
    });
  };

  const cancelMatch = async () => {
    console.log('would cancel here...');
  };

  return { declareWinner, delayMatch, cancelMatch };
};
